import { useMutation } from "react-query";
import { postAmendRiskExecute } from "store/api/api";
import { handleAxiosError } from "store/util";
import { AmendRiskCheckRequest } from "types/types";
import { MUTATION_KEYS } from "../queryKeys";

export function useAmendRiskExecute() {
  return useMutation(
    ({
      fleetId,
      vehicleId,
      data,
    }: {
      fleetId: number;
      vehicleId: number;
      data: AmendRiskCheckRequest;
    }) => postAmendRiskExecute(fleetId, vehicleId, data),
    {
      mutationKey: MUTATION_KEYS.amendRiskExecute,
      onError: (err) => {
        handleAxiosError(err);
      },
    },
  );
}
